import { fa } from 'vuetify/iconsets/fa-svg';

import { $i, skIconAliases } from '@silae/composables/icons';

export const vuetifyIcons = {
	defaultSet: 'fa',
	aliases: {
		...skIconAliases,
		radioOn: $i('circle-dot'),
		info: $i('circle-info'),
		warning: $i('circle-exclamation'),
		error: $i('circle-xmark'),
		success: $i('circle-check')
	},
	sets: {
		fa
	}
};
